import AnimatedContent from './AnimatedContent';
import SectionOverlap from './SectionOverlap';

const FeaturesSection = () => {
  const features = [
    {
      title: "Full-Stack Development",
      description: "Building scalable web applications with modern technologies like React, Node.js, and Python."
    },
    {
      title: "UI/UX Design",
      description: "Creating intuitive and beautiful user interfaces that enhance user experience and engagement."
    },
    {
      title: "Mobile Development",
      description: "Developing cross-platform mobile applications using Flutter."
    },
    {
      title: "Cloud Solutions",
      description: "Still learning"
    },
    {
      title: "API Development",
      description: "Still learning"
    },
    {
      title: "Performance Optimization",
      description: "Optimizing applications for speed, scalability, and better user experience."
    }
  ];

  return (
    <SectionOverlap
      overlapType="slide"
      overlapDistance={80}
      overlapDirection="up"
      zIndex={5}
      className="features-section-wrapper"
    >
      <section id="features" className="features-section">
        <div className="section-container">
          <AnimatedContent
            distance={150}
            direction="vertical"
            reverse={false}
            duration={1.2}
            ease="bounce.out"
            initialOpacity={0.2}
            animateOpacity
            scale={1.1}
            threshold={0.2}
            delay={0.3}
          >
            <h2 className="section-heading">Skills & Expertise</h2>
          </AnimatedContent>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card feature-card-glow">
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </SectionOverlap>
  );
};

export default FeaturesSection;